export default "__VITE_ASSET__fe336a31__"